var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1D20667-DBDC-461F-895E-AC602C3246CF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-provider-profile-2",
    transform: "translate(-891.000000, -125.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Primary/Action/X",
    transform: "translate(886.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-x",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,7.0596608 L14.2744196,1.2852412 C14.6649439,0.894716906 15.2981089,0.894716906 15.6886332,1.2852412 L15.7147588,1.31136683 C16.1052831,1.70189112 16.1052831,2.3350561 15.7147588,2.72558039 L9.9403392,8.5 L15.7147588,14.2744196 C16.1052831,14.6649439 16.1052831,15.2981089 15.7147588,15.6886332 L15.6886332,15.7147588 C15.2981089,16.1052831 14.6649439,16.1052831 14.2744196,15.7147588 L8.5,9.9403392 L2.72558039,15.7147588 C2.3350561,16.1052831 1.70189112,16.1052831 1.31136683,15.7147588 L1.2852412,15.6886332 C0.894716906,15.2981089 0.894716906,14.6649439 1.2852412,14.2744196 L7.0596608,8.5 L1.2852412,2.72558039 C0.894716906,2.3350561 0.894716906,1.70189112 1.2852412,1.31136683 L1.31136683,1.2852412 C1.70189112,0.894716906 2.3350561,0.894716906 2.72558039,1.2852412 L8.5,7.0596608 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f297f303716701604b050ea72984ec72.svg";
export { ForwardRef as ReactComponent };